import { useQueryClient } from '@tanstack/react-query';
import { userTutorialEntity } from '@/data/entities/userTutorial';
import { getPrefixes, useCustomMutation } from '@/data/mutations';
import { userTutorialTransport } from '@/data/userTutorial';
import type { UserTutorial, UserTutorialPatch } from '@/types';

const invalidate = getPrefixes('userTutorial', 'update');

interface UpdateUserTutorialParams {
    userId: number;
    patch: UserTutorialPatch;
}

/**
 * `PUT user/tutorial` (see `data/userTutorial.ts`). The answer is the
 * whole stored state, written into the cache as it arrives: a caller that
 * navigates right after the write (the seed storing `project_id`) must not
 * read the old state while the refetch is in flight.
 */
export function useUpdateUserTutorial() {
    const queryClient = useQueryClient();
    return useCustomMutation<UpdateUserTutorialParams, UserTutorial>({
        mutationFn: ({ userId, patch }) => userTutorialTransport.put(userId, patch),
        onSuccess: (tutorial, { userId }) => {
            queryClient.setQueryData(userTutorialEntity.fetchers.get.key({ userId }), tutorial);
        },
        invalidate,
    });
}
